// extracted by mini-css-extract-plugin
export default {"container":"TextSearchInput__container___D8dIw"};